import api_config from '../config/api'

export default {
	async getBanners() {
		return api_config.get('api/banner')
	},
}
